

import { useState, useEffect } from "react";
import CustomText, { textStyles } from "../../components/CustomText";
import { Box } from "@mui/material";
import more from "../../assets/more.svg";
import Card from "../../components/cards/TeamCard";
import GetAppButton from "../../components/GetAppButton";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import topline1 from "../../assets/topline1.png";
import topline2 from "../../assets/topline2.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../components/BASE_URL";

// 🔹 Images
import team1 from "../../assets/team1.png";
import team2 from "../../assets/team2.png";
import team3 from "../../assets/team3.png";
import team4 from "../../assets/team4.webp";

import team11 from "../../assets/team11.png";
import team12 from "../../assets/team12.png";
import team13 from "../../assets/team13.png";

import team21 from "../../assets/team21.png";
import team22 from "../../assets/team22.png";
import team23 from "../../assets/team23.png";

import team31 from "../../assets/team31.png";
import team32 from "../../assets/team32.png";
import team33 from "../../assets/team33.png";

import team41 from "../../assets/team41.png";
import team42 from "../../assets/team42.png";
import team43 from "../../assets/team43.png";
import team44 from "../../assets/team44.png";

import team1es from "../../assets/spanish/Home/team1es.png";
import team2es from "../../assets/spanish/Home/team2es.png";
import team3es from "../../assets/spanish/Home/team3es.png";

// 🔹 Skeleton loader
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useSocialLinks } from "../../components/fetchGetAppUrl";
const TeamBiometricSection = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));
  const { links} = useSocialLinks();

  const hero_section_button_text = {
    main: "var(--Tertiary, #003149)",
    hover: "#00263a",
    contrastText: "#FFFFFF",
    fontSize: "18px",
  };

  // ✅ Map for images/icons (fixed order like before)
  const Card1 = i18n.language === "es" ? team1es : team1;
  const Card2 = i18n.language === "es" ? team2es : team2;
  const Card3 = i18n.language === "es" ? team3es : team3;

  const cardAssets = [
    {
      image: Card1,
      icons: [
        { src: team11, alt: "Camera Icon" },
        { src: team12, alt: "Check Icon" },
        { src: team13, alt: "Smiley Icon" },
      ],
    },
    {
      image: Card2,
      icons: [
        { src: team21, alt: "Camera Icon" },
        { src: team22, alt: "Check Icon" },
        { src: team23, alt: "Smiley Icon" },
      ],
    },
    {
      image: Card3,
      icons: [
        { src: team31, alt: "Camera Icon" },
        { src: team32, alt: "Check Icon" },
        { src: team33, alt: "Smiley Icon" },
      ],
    },
    {
      image: team4,
      icons: [
        { src: team41, alt: "Camera Icon" },
        { src: team42, alt: "Check Icon" },
        { src: team43, alt: "Smiley Icon" },
        { src: team44, alt: "Smiley Icon" },
      ],
    },
  ];

  // 🔹 API State
  const [trustData, setTrustData] = useState({
    title: "",
    description: "",
    list: [],
  });
  const [loading, setLoading] = useState(true);
useEffect(() => {
  async function loadTrust() {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Home_Features_Trust`
      );
      const json = await res.json();

      const section = (json?.data || []).find(
        (s) => s?.name?.trim().toLowerCase() === "home_features_trust"
      );

      if (section?.items?.length) {
        const selectedItem =
          i18n.language === "es"
            ? section.items.find((item) => item.idx === 1)
            : section.items.find((item) => item.idx === 0);

        const parsedList = Array.isArray(selectedItem?.list)
          ? selectedItem.list
          : selectedItem?.list
            ? JSON.parse(selectedItem.list)
            : [];

        setTrustData({
          title: selectedItem?.title || "",
          description: selectedItem?.description || "",
          list: parsedList,
        });
      }
    } catch (err) {
      console.error("Error loading trust features:", err);
    } finally {
      setLoading(false);
    }
  }

  loadTrust();
}, [i18n.language]);


  const handleMore = () => {
    navigate("/product-tour");
  };

  return (
    <Box
      sx={{
        marginTop: isMobile ? "20px" : "80px",
        paddingTop: isMobile ? "40px" : "100px",
        paddingBottom: "100px",
        background: `url(${topline1}) top right no-repeat, 
                url(${topline2}) top right no-repeat, 
                url(${topline1}) bottom left no-repeat,
                url(${topline2}) bottom left no-repeat`,
        backgroundSize: "30% 30%, 30% 30%, 30% 30%, 30% 30%",
        backgroundPosition:
          "top right, top right 20px, bottom left, bottom left 20px",
        backgroundRepeat: "no-repeat, no-repeat, no-repeat, no-repeat",
        position: "relative",
        px: isMobile ? 2 : isTablet ? 2 : 13,
      }}
    >
      {/* 🔹 Heading from API or Skeleton */}
      <CustomText
        style={{
          ...textStyles.h3,
          marginBottom: "1rem",
          marginTop: "1rem",
          color: "#072533",
          fontSize: isMobile ? "30px" : "48px",
        }}
      >
        {loading ? <Skeleton width={300} height={40} /> : trustData.title}
      </CustomText>

      {/* 🔹 Description from API or Skeleton */}
      <CustomText
        style={{
          ...textStyles.body2,
          color: "#868282",
          textAlign: "center",
          margin: "0 auto",
          marginTop: "10px",
        }}
      >
        {loading ? <Skeleton width={600} height={20} /> : trustData.description}
      </CustomText>

      {/* 🔹 Cards */}
      <Box style={{ marginTop: "40px" }}>
        {loading
          ? Array.from({ length: 4 }).map((_, i) => (
              <Box key={i} sx={{ mb: 4 }}>
                <Skeleton height={250} />
              </Box>
            ))
          : trustData.list.map((feature, index) => {
              const asset = cardAssets[index] || {};
              return (
                <Card
                  key={feature.id || index}
                  image={asset.image || null}
                  title={feature.name}
                  description={feature.value}
                  icons={asset.icons || []}
                  isImageLeft={index % 2 !== 0}
                />
              );
            })}
      </Box>

      {/* 🔹 Buttons */}
      <Box
        sx={{
          display: "flex",
          flexWrap: isMobile ? "wrap" : "nowrap",
          justifyContent: "center",
          alignItems: "center",
          mt: isMobile ? "0px" : 10,
          gap: 1,
        }}
      >
        <GetAppButton
          label={t("get_app_now")}
          variant="primary"
          size={i18n.language === "es" ? "medium" : "large"}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 0,
            cursor: "pointer",
          }}
          onClick={handleMore}
        >
          <img
            src={more || "/placeholder.svg"}
            style={{ width: "65px", height: "65px" }}
            alt="Learn more"
          />
          <p
            style={{
              color: hero_section_button_text.main,
              fontSize: "18px",
              fontWeight: 600,
              fontFamily: "Poppins, sans-serif",
              cursor: "pointer",
            }}
          >
            {t("Learn More")}
          </p>
        </Box>
      </Box>
    </Box>
  );
};

export default TeamBiometricSection;


